import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getPageTitle } from '@/utils/get-page-title'
import { getSchoolMark } from '@/utils/index'
import { getToken } from '@/utils/auth'
import Store from '@/store'
import { Message } from 'element-ui'
// import API from '@/api'
// 返回小程序页面

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/change-password', '/404'] // no redirect whitelist

// eslint-disable-next-line
router.beforeEach(async (to, from, next) => {

  // set page title
  document.title = getPageTitle(to.meta.title, Store.state.app.appConfig.organization)
  document.documentElement.style.setProperty('--theme-color', Store.state.app.appConfig.theme_color)

  await Store.dispatch('app/getSysteamSetting')
  if (whiteList.indexOf(to.path) === -1) {
    await Store.dispatch('user/GetUserInfo')
  }

  if (!getSchoolMark()) {
    Message.error('请先选择学校')
    return
  }

  NProgress.start()
  // 确定用户是否已登录
  const hasToken = getToken()

  const source = window.localStorage.getItem('source')

  if (hasToken) {
    if (to.path === '/login') {
      // 如果已登录，重定向到主页
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasGetUserInfo = Store.getters.name
      if (hasGetUserInfo || source === 'miniprogram') {
        next()
      } else {
        await Store.dispatch('user/resetToken')
        // Message.error('Has Error')
        next(`/login?&redirect=${to.fullPath}`)
        NProgress.done()
      }
    }
  } else {
    /* has no token*/
    await Store.dispatch('user/resetToken')
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.fullPath}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
